import { useState } from 'react';
import { Box } from '@mui/material';
import { FloatingActionsMenu } from '@elementary/common-ui/components';
import { TestRuns } from '@elementary/common-ui/pages';
import { DEFAULT_DAYS_BACK } from '@elementary/common-ui/constants';
import useDebounce from '@elementary/common-ui/hooks/useDebounce';
import useTestRuns from './useTestRuns';
import TestRunsExpandedRow from './components/TestRunsExpandedRow';

const TestRunsPage = () => {
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 500);

  const data = useTestRuns({ search: debouncedSearch });

  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
      <TestRuns
        {...data}
        daysBack={DEFAULT_DAYS_BACK}
        search={search}
        onSearch={setSearch}
        defaultSortKey="metadata.latest_run_time"
        defaultSortDirection="desc"
        expandedRowRenderer={(rowData) => (
          <TestRunsExpandedRow rowData={rowData} />
        )}
      />
      <FloatingActionsMenu />
    </Box>
  );
};

export default TestRunsPage;
